import { DETAILED, SLUGS } from "@components/home/routes";
import MainWrapper from "@components/pages/common/MainWrapper";
import {
  RAQ_FORM_TYPES,
  RAQ_PAGE_TYPE,
  RaqPageType,
  STORAGE_LIKES,
} from "@components/utils/constants";
import { handleResponseCode } from "@components/utils/getStaticPropsHelpers";
import useAppContext from "@hooks/useAppContext";
import useModalScrollFreeze from "@hooks/useModalScrollFreeze";
import DetailsPage from "@modules/detailsPage/DetailsPage";
import fetchGet from "@services/api/fetchGet";
import baseApiCalls from "@services/baseApiCalls";
import detectRedirect from "@services/detectRedirect";
import { GetStaticPaths, GetStaticProps } from "next";
import { RaQFormType } from "pages/things-to-do/[...slug]";
import { useState } from "react";
import { IDefaultPagePropsResponse } from "../../types/commonResponses";
import { PAGE_TYPES } from "../../types/index";
import {
  ILocationResponse,
  IPackageResponse,
  IRegionResponse,
} from "../../types/modelResponses";

interface IPackageDetailsPage extends IDefaultPagePropsResponse {
  data: IPackageResponse;
  regions: IRegionResponse;
  pageType: RaqPageType;
  raqFormType: RaQFormType;
}

function PackageDetail(props: IPackageDetailsPage): JSX.Element {
  const appContext = useAppContext();
  const [viewAllActivities, openViewAllActivities] = useState(false);
  const [viewAllAccommodations, openViewAllAccommodations] = useState(false);

  useModalScrollFreeze([
    viewAllAccommodations,
    viewAllActivities,
    appContext?.showLoginModal,
  ]);

  return (
    <MainWrapper>
      <DetailsPage
        data={props.data}
        topNavigation={props.topNavigation}
        raqFormType={props.raqFormType}
        pageType={RAQ_PAGE_TYPE.PACKAGE}
        likesType={STORAGE_LIKES.packages}
        openViewAllActivities={openViewAllActivities}
        openViewAllAccommodations={openViewAllAccommodations}
        viewAllActivities={viewAllActivities}
        viewAllAccommodations={viewAllAccommodations}
      />
    </MainWrapper>
  );
}
export default PackageDetail;

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetchGet(SLUGS.PACKAGES);
  const packages = await res.json();

  const paths = packages.map((e: Pick<IPackageResponse, "SEO">) => ({
    params: { slug: e?.SEO?.Slug.split("/") },
  }));

  return { paths, fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const redirect = await detectRedirect(`packages/${params?.slug?.[0]}`);
  if (redirect) {
    return redirect;
  }

  const packagesData = await fetchGet(
    `${DETAILED.PACKAGES}${
      Array.isArray(params?.slug) ? params?.slug.join("@") : ""
    }`
  );

  const { pageNotFound, hasInternalError } = handleResponseCode(packagesData);

  if (pageNotFound) {
    return {
      notFound: true,
      revalidate: Number(process.env.REVALIDATE_TIMER),
    };
  }

  const packages = hasInternalError ? null : await packagesData.json();
  const allPackages = hasInternalError ? null : packages?.allPackages;

  const pageType = hasInternalError
    ? PAGE_TYPES.InternalErrorPage
    : PAGE_TYPES.Packages;

  const allRegions = hasInternalError
    ? null
    : packages?.locations
        ?.reduce((acc: [], location: ILocationResponse) => {
          const locRegions = location.regions ?? [];
          return [...acc, ...locRegions];
        }, [])
        .filter(
          (value: ILocationResponse, index: number, self: any) =>
            index === self.findIndex((t: any) => t.id === value.id)
        );

  //const raqFormData = await fetchGet(RAQ_FORM);
  //const raqForm = await raqFormData.json();

  const {
    footer,
    mediaAssets,
    searchManagementRes,
    topNavigation,
    menus,
    usp,
  } = await baseApiCalls();
  return {
    props: {
      footer,
      data: packages,
      mediaAssets,
      topNavigation,
      regions: allRegions,
      allPackages,
      pageType,
      menus,
      usp,
      //raqFormType: raqForm?.Form_Type || RAQ_FORM_TYPES.FORM_A,
      raqFormType: RAQ_FORM_TYPES.FORM_B,
      searchManagement: searchManagementRes,
      hasInternalError,
    },
    revalidate: Number(process.env.REVALIDATE_TIMER),
  };
};
